import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import Form from './Form'
import RichText from './Form/RichText'
import { withSettings } from './withSettings'
import Toggle from "./Form/toggle"
import PremiumLabel from "./Form/PremiumLabel"
import {isPremium} from "../../../../utils/plans"

@withSettings
@inject(['websites'])
@observer
export default class SeoSettings extends Component {
  website = this.props.websites.current

  handleData = data => {
    return this.props.setSettingsAt('seo', data)
  }

  render() {
    const { default_url } = this.website
    const seo = this.props.getSettingsAt('seo')
    const dynamicFields = this.props.getDynamicFieldsFor('listing_data')
    const sitemapUrl = `${default_url}xmlsitemap/`
    let site_map
    if(seo.site_map == 0) {
      site_map = false
    }else if (seo.site_map == 1){
      site_map = true
    }else {
      site_map = seo.site_map
    }

    return (
      <div className="container padded settings">
        <Form onData={this.handleData}>
          <div className="panel padded">
          <h2 className="title">SEO Settings</h2>
            <div className="form-section">
              <Toggle
                  disabled={!isPremium(this.website.plan)}
                  on={site_map}
                  name="site_map"
              >
                <span>
                  XML Sitemap <PremiumLabel website={this.website}/>
                </span>
                <p className="muted">
                  Your website has a XML Sitemap that you can submit to Google Search Console. You'll find it at the
                  following URL:
                </p>
                <label><a href={sitemapUrl}>{sitemapUrl}</a></label>
              </Toggle>
            </div>
          </div>

          <div className="panel padded">
            <div className="form-section">
              <label><strong>Analytics</strong></label>
              <p className="muted">
                Enter your Google Analytics tracking ID (UA or GA4 code).
              </p>
              <input type="text" name="ga_code" defaultValue={seo.ga_code} placeholder="UA-XXXXXXXX-X" />
            </div>
          </div>

          <div className="panel padded">
            <div className="form-section">
              <label><strong>Meta Page Content Templates</strong></label>
              <p className="muted">
                You have the ability to customize the way that each page is
                displayed to browsers and search engines.
              </p>
            </div>

            <div className="form-section">
              <label>Search Page Title</label>
              <p className="muted">
                This text for the main search page title.
              </p>
              <input type="text" name="search_title" defaultValue={seo.search_title} placeholder="Search" />
            </div>

            <div className="form-section">
              <label>Search Page Meta Description</label>
              <p className="muted">
                This text for the main search page meta description.
              </p>
              <input type="text" name="search_description" defaultValue={seo.search_description} placeholder="Description" />
            </div>

            <div className="form-section">
              <label>Listing Detail Page URL Structure</label>
              <p className="muted">
                You can customize the URL Structure of the listing detail pages
                on your site.
              </p>
              <p className="muted caution">
                Warning: Do not do this often as it will create havoc with the
                search engines and their ability to find valid pages. Also
                avoid using dynamic fields that are likely to change such as
                price.
              </p>
              <RichText
                name="ldp_url_template"
                defaultValue={seo.ldp_url_template}
                dynamicFields={dynamicFields}
                processPreviewDynamicFields={(name, value) => encodeURIComponent(value.replace(/ /g, '-'))}
                processPreviewResults={val => `<p>${`${default_url}listing/sidx/1234567/${val.replace(/<\/?p>/g, '')}`}</p>`}
                singleline />
            </div>

            <div className="form-section">
              <label>Listing Detail Page Title</label>
              <p className="muted">
                This template configures the Page title at the top of each
                listing detail page.
              </p>
              <RichText
                name="ldp_title_template"
                defaultValue={seo.ldp_title_template}
                dynamicFields={dynamicFields}
                singleline />
            </div>

            <div className="form-section">
              <label>Listing Detail Page Meta Description</label>
              <p className="muted">
                This template configures the meta description. Often this is
                what the search engine uses for the description in a search result.
              </p>
              <RichText
                name="ldp_meta_description_template"
                defaultValue={seo.ldp_meta_description_template}
                dynamicFields={dynamicFields}
                singleline />
            </div>
          </div>

          <button type="submit" className="big shadowed">Save Changes</button>
        </Form>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/website/settings/SEO.js